<div class="gt">
  <div class="bk-panel gt__panel">
    <data-table label="Segments" [seamless]="true" [loading]="loading" [maxHeight]="'640px'" [skeletonColumns]="5">
      @if (loadError) {
        <div class="gt-error" role="alert">
          <p class="gt-error__text">{{ loadError }}</p>
          <button type="button" class="bk-btn bk-btn--ghost" (click)="load()">Load again</button>
        </div>
      } @else if (rows.length > 0) {
        <table class="bk-log">
          <thead>
            <tr>
              <th scope="col" class="col-check">
                <label class="gt-check-hit">
                  <input
                    type="checkbox"
                    class="gt-check"
                    [checked]="getIsAllSelected"
                    [indeterminate]="someOnPageSelected"
                    (change)="toggleSelectAllSegments()"
                    aria-label="Select every segment on this page"
                  />
                  <span class="gt-check-all" aria-hidden="true">Select all</span>
                </label>
              </th>
              <th scope="col" class="col-name">Segment</th>
              <th scope="col" class="col-num">Members</th>
              <th scope="col" class="col-b">Created by</th>
              <th scope="col" class="col-a">Updated</th>
              <th scope="col" class="col-actions"><span class="bk-sr-only">Actions</span></th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row.key) {
              <tr
                class="is-link"
                tabindex="0"
                [class.is-selected]="getSegmentIsSelected(row.segment)"
                (click)="goToSegmentDetails(row.segment.uuid || '')"
                (keydown.enter)="openFromKeyboard($event, row.segment)"
              >
                <td class="col-check" (click)="$event.stopPropagation()">
                  <label class="gt-check-hit">
                    <input
                      type="checkbox"
                      class="gt-check"
                      [checked]="getSegmentIsSelected(row.segment)"
                      (change)="selectSegment(row.segment)"
                      [attr.aria-label]="'Select ' + row.name"
                    />
                  </label>
                </td>
                <td class="col-name">
                  <span class="bk-msg">
                    <span class="bk-msg__subject">{{ row.name }}</span>
                    <span class="bk-msg__preview" [attr.title]="row.rule || null">
                      @if (row.legacy) {
                        <span class="gt-flag">Needs a re-save</span>
                      }
                      @if (row.rule) {
                        {{ row.rule }}
                      } @else {
                        <span class="gt-faint">No conditions</span>
                      }
                    </span>
                  </span>
                </td>
                <td class="col-num">
                  @switch (countState(row.segment)) {
                    @case ('loading') {
                      <span class="bk-skel gt-count-skel" aria-hidden="true"></span>
                      <span class="bk-sr-only">Counting members</span>
                    }
                    @case ('none') {
                      <span class="gt-faint" title="The member count did not load" aria-hidden="true">—</span>
                      <span class="bk-sr-only">Count did not load</span>
                    }
                    @default {
                      <span class="gt-count">{{ formatCount(countOf(row.segment)) }}</span>
                      <span class="gt-num-label">{{ countOf(row.segment) === 1 ? ' member' : ' members' }}</span>
                    }
                  }
                </td>
                <td class="quiet col-b">{{ row.createdBy }}</td>
                <td class="quiet col-a" [attr.title]="row.updatedTitle">{{ row.updated }}</td>
                <td class="col-actions">
                  <span class="bk-row-actions">
                    <button
                      *hasPermission="{ category: 'MESSAGE_CONTENT_MANAGEMENT', permission: 'compose-sms' }"
                      type="button"
                      class="bk-icon-btn"
                      [attr.aria-label]="'Message ' + row.name"
                      matTooltip="Message this segment"
                      (click)="$event.stopPropagation(); messageSegment(row.segment)"
                    >
                      <span class="bk-sym" aria-hidden="true">send</span>
                    </button>
                    <button
                      *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'manage-contact-groups' }"
                      type="button"
                      class="bk-icon-btn"
                      [attr.aria-label]="'Edit ' + row.name"
                      matTooltip="Edit"
                      (click)="$event.stopPropagation(); handleGoToEditSegment(row.segment)"
                    >
                      <span class="bk-sym" aria-hidden="true">edit</span>
                    </button>
                    <button
                      *hasPermission="{ category: 'CONTACT_MANAGEMENT', permission: 'manage-contact-groups' }"
                      type="button"
                      class="bk-icon-btn gt-danger"
                      [attr.aria-label]="'Delete ' + row.name"
                      matTooltip="Delete"
                      (click)="$event.stopPropagation(); openDeleteModal(row.segment)"
                    >
                      <span class="bk-sym" aria-hidden="true">delete</span>
                    </button>
                    <span class="bk-sym row-go" aria-hidden="true">chevron_right</span>
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <app-empty-state
          icon="segments"
          message="No segments yet"
          [hint]="searchTerm.trim() ? '' : 'Create one with New segment to pick contacts by city, age, gender and more.'"
          [query]="searchTerm"
          size="medium"
          (clear)="clearFilters.emit()"
        />
      }
    </data-table>
  </div>

  @if (!loadError && segmentPagination.totalElements > 0) {
    <div class="gt__pager">
      <app-pagination
        [currentPage]="segmentPagination.pageNumber"
        [totalPages]="segmentPagination.totalPages"
        [totalItems]="segmentPagination.totalElements"
        [pageSize]="pageSize"
        [loading]="loading"
        (changePage)="updateSegmentPage($event)"
        (onNext)="goToNextPage()"
        (onPrev)="goToPreviousPage()"
        (pageSizeChange)="onPageSizeChange($event)"
      />
    </div>
  }

  <!-- MODALS -->
  <app-prompt-card
    [title]="'Delete ' + (selectedSegment?.name || 'this segment') + '?'"
    buttonText="Delete segment"
    tone="danger"
    impact="This cannot be undone."
    impactIcon="warning"
    [openModal]="showDeleteModal"
    (onClose)="closeDeleteModal()"
    (onButtonClick)="handleDeleteSegment()"
    [loading]="deleting"
  >
    <p class="gt-prompt">{{ deleteImpact }}</p>
  </app-prompt-card>
</div>
